import React, { Fragment } from 'react';
import './ProjectSinglePage.css'
import { Link, useParams } from 'react-router-dom'
import Projects from '../../api/projects';
import HeaderTop from '../../components/HeaderTop/HeaderTop'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'

import MapSection from '../../components/MapSection/MapSection';

import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from '../../images/logo.svg'


import Footer from '../../components/footer/Footer';

const ProjectSinglePage = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { slug } = useParams()
    
    // Find current project index
    const currentIndex = Projects.findIndex(item => item.slug === slug)
    const ProjectDetails = Projects[currentIndex]
    
    // Get previous and next projects
    const prevProject = currentIndex > 0 ? Projects[currentIndex - 1] : null
    const nextProject = currentIndex < Projects.length - 1 ? Projects[currentIndex + 1] : null

    // Handle case where project is not found
    if (!ProjectDetails) {
        return <div>Project not found</div>
    }

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <section className={`wpo-breadcumb-area`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={ProjectDetails.title} />
            </section>
            <section className="wpo-project-single-page section-padding">
                <div className="container">
                    <div className="project-wrap">
                        <div className="project-top-info">
                            <div className="row align-items-center">
                                <div className="col-12">
                                    <div className="wpo-section-title">
                                        <h2>Trusted electricity Care</h2>
                                        <h3>{ProjectDetails.title}</h3>
                                        <p>{ProjectDetails.docomunt}</p>
                                        <Link onClick={ClickHandler} to="#" className="theme-btn">Visit Website <i className="ti-angle-right"></i></Link>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-12 d-none">
                                    <div className="project-info">
                                        <ul>
                                            <li>
                                                <h3>Clients</h3>
                                                <span>Design Studio In USA </span>
                                            </li>
                                            <li>
                                                <h3>Project Type</h3>
                                                <span>Digital Product Design</span>
                                            </li>
                                            <li>
                                                <h3>Date</h3>
                                                <span>25 October 2024 </span>
                                            </li>
                                            <li>
                                                <h3>Website</h3>
                                                <span>wiatech.com</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="image-gallery">
                                <ul>
                                    <li><img src={ProjectDetails.pSimg} alt="" /></li>
                                    <li><img src={ProjectDetails.pSimg2} alt="" /></li>
                                </ul>
                            </div>
                            {/* <div className="info-content">
                                <div className="info-item">
                                    <div className="left">
                                        <h2>Interesting facts in
                                            Development</h2>
                                    </div>
                                    <div className="right">
                                        <p>Must explain to you how all this mistaken idea of denouncing pleasure and
                                            praising
                                            pain was born and I will give you a complete account of the system, and expound
                                            the
                                            actual teachings of the great explorer of the truth, the master-builder of human
                                            happiness. No one rejects, dislikes, or avoids pleasure itself, because it is
                                            pleasure, but because those who do not know how to pursue pleasure rationally
                                            encounter</p>
                                        <div className="item">
                                            <ul>
                                                <li>Efficient Sprint Planning</li>
                                                <li>Standups and Demos</li>
                                            </ul>
                                            <ul>
                                                <li>Iterative Delivery Approach</li>
                                                <li>Problem-solving</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="info-item">
                                    <div className="left">
                                        <h2>The Results of
                                            Our Project</h2>
                                    </div>
                                    <div className="right s2">
                                        <p>Will give you a complete account of the system, and expound the actual teachings
                                            of the great explorer of the truth, the master-builder of human happiness
                                            rejects, dislikes, or avoids pleasure </p>
                                        <div className="item">
                                            <ul>
                                                <li>
                                                    <h3><i className="flaticon-check"></i>Support clients</h3>
                                                    <span>Sed ut perspiciatis unde omnis natus voluptatem accusantium
                                                        doloremque laudantium, totam rem aperiam inventore</span>
                                                </li>
                                                <li>
                                                    <h3><i className="flaticon-check"></i>Solve problems</h3>
                                                    <span>Sed ut perspiciatis unde omnis natus voluptatem accusantium
                                                        doloremque laudantium, totam rem aperiam inventore</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-img">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className='d-img'>
                                            <img src={Gimg1} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className='d-img'>
                                            <img src={Gimg2} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="page-chang">
                                {/* Previous Post */}
                                <div className="previous-post post">
                                    {prevProject ? (
                                        <>
                                            <Link onClick={ClickHandler} to={`/project/${prevProject.slug}`} className="next">
                                                <i className="ti-angle-left"></i> Previous
                                            </Link>
                                            <Link onClick={ClickHandler} to={`/project/${prevProject.slug}`}>
                                                {prevProject.title}
                                            </Link>
                                        </>
                                    ) : (
                                        <>
                                            <span className="next disabled">
                                                <i className="ti-angle-left"></i> Previous
                                            </span>
                                            <span className="disabled-text">No previous project</span>
                                        </>
                                    )}
                                </div>
                                
                                {/* Next Post */}
                                <div className="next-post post">
                                    {nextProject ? (
                                        <>
                                            <Link onClick={ClickHandler} to={`/project/${nextProject.slug}`} className="next">
                                                Next <i className="ti-angle-right"></i>
                                            </Link>
                                            <Link onClick={ClickHandler} to={`/project/${nextProject.slug}`}>
                                                {nextProject.title}
                                            </Link>
                                        </>
                                    ) : (
                                        <>
                                            <span className="next disabled">
                                                Next <i className="ti-angle-right"></i>
                                            </span>
                                            <span className="disabled-text">No next project</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <MapSection />
            {/* <CtaSection hclass={'wpo-cta-section-s2'} /> */}
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};

export default ProjectSinglePage;